import { Pipe, PipeTransform } from '@angular/core';

/**
 * Transforms date from little endian to big endian. https://en.wikipedia.org/wiki/Date_format_by_country
 */
@Pipe({ name: 'evConvertDateToBigEndian',  pure: false })
export class ConvertDateToBigEndianPipe implements PipeTransform {

  /**
   * Transforms date from little endian to big endian. https://en.wikipedia.org/wiki/Date_format_by_country
   *
   * @param value Value passed to this method via pipe in template
   * @param args Any additional arguments
   */
  public transform(value: any, args: Array<any> = null): any {
    const splittedDate = value.split('.');
    const yearItem: number = 2;
    const year: number = splittedDate[yearItem];

    const monthItem: number = 1;
    const month = splittedDate[monthItem];

    const dayItem: number = 0;
    const day = splittedDate[dayItem];

    return `${year}-${month}-${day}`;
  }
}
